// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6291) return "static/chunks/6291-3b03aa7135779519.js";
	if (chunkId === 5973) return "static/chunks/5973-02be5c98cd6bc71c.js";
	// return url for filenames based on template
	return "static/chunks/" + {"3496":"graphql-print","4254":"56c12eb5","5970":"lottie"}[chunkId] + "." + {"3496":"7ef39872c8b54dd4","4254":"cfaf0f642ce9413b","5970":"b7d77b1b9bc21f3d"}[chunkId] + ".js";
};